module.exports = __webpack_public_path__ + "img/list-bullets.001cf330.svg";